import React from "react";
import { Card } from "./ui/card";
import { Brain, Users, Clock, TrendingUp, Shield, Zap } from "lucide-react";
import { valueProps } from "../data/mockData";

const iconMap = {
  Brain,
  Users,
  Clock,
  TrendingUp,
  Shield,
  Zap
};

const ValuePropositions = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose PropertySellEasy?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We combine cutting-edge AI technology with an extensive network of real estate professionals 
            to deliver results that traditional methods simply can't match.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {valueProps.map((prop, index) => {
            const IconComponent = iconMap[prop.icon];
            const colorClass = prop.color === 'blue' ? 'text-blue-600 bg-blue-100' : 'text-green-600 bg-green-100';
            
            return (
              <Card key={index} className="p-8 hover:shadow-lg transition-shadow duration-300">
                <div className={`w-16 h-16 rounded-lg ${colorClass} flex items-center justify-center mb-6`}>
                  <IconComponent className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{prop.title}</h3>
                <p className="text-gray-600 leading-relaxed">{prop.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositions;